/*
 * @Author: cyl
 * @Date: 2022-09-05 16:37:22
 * @LastEditors: cyl
 * @LastEditTime: 2022-09-06 16:35:30
 * @Description:登录接口api
 */

import { get, getOther, post, put } from "@/network/loginRequest/axios.js";

/**
 * @description: 微信扫码登录获取二维码内路径
 * @return {*}
 */
export const tempAddSmarkQrCode = () => {
  return get(`/security/web/user/tempAddSmarkQrCode`);
};
/**
 * @description: 取消扫码
 * @return {*}
 */
export const cancelCodeLogin = () => {
  return get(`/security/web/user/cancelCodeLogin`);
};
/**
 * @description: 扫码登录
 * @return {*}
 */
export const QRLogin = (data) => {
  return get(`/security/web/user/pcQrCodeLoginState`, data);
};
